import React from "react";
import PropTypes from "prop-types";

import useYouTubeConsent from "./YouTubeConsent/useYouTubeConsent";
import WatchOnYouTubeLink from "./YouTubeConsent/WatchOnYouTubeLink";
import YouTubeConsentPrompt from "./YouTubeConsent/YouTubeConsentPrompt";

// A 16:9 YouTube video that loads nothing from YouTube until the viewer has allowed its
// cookies. Rendered client-side only, so the iframe isn't in the page HTML for the
// browser to fetch before the cookie tool can block it.
const YouTubeEmbed = ({ title, videoId }) => {
  const { acceptCookies, consented } = useYouTubeConsent();

  return (
    <div className="youtube-embed">
      <div className="youtube-embed-frame">
        {consented ? (
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            src={`https://www.youtube.com/embed/${videoId}?rel=0`}
            title={title}
          />
        ) : (
          <YouTubeConsentPrompt onAccept={acceptCookies} />
        )}
      </div>
      {consented && <WatchOnYouTubeLink href={`https://www.youtube.com/watch?v=${videoId}`} />}
    </div>
  );
};

YouTubeEmbed.propTypes = {
  title: PropTypes.string,
  videoId: PropTypes.string.isRequired,
};

YouTubeEmbed.defaultProps = {
  title: "YouTube video player",
};

export default YouTubeEmbed;
